import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept-data-type";

// export const getAllConceptDataType = () => axios.get(API_PATH + "/get-all");

export const pagingConceptDataType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getConceptDataTypeById = (conceptDataTypeId) => axios.get(API_PATH + "/" + conceptDataTypeId);

export const saveConceptDataType = conceptDataType => axios.post(API_PATH, conceptDataType);

export const updateConceptDataType = conceptDataType => axios.put(API_PATH + "/" + conceptDataType?.id, conceptDataType);

export const deleteConceptDataType = conceptDataTypeId => axios.delete(API_PATH + '/' + conceptDataTypeId);
